(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-your-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cylInit) return; window.__cylInit = true;
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cyl-add]');
    if (!btn || btn.disabled) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');
    var sections = [];
    if (drawer) sections.push('cart-drawer');
    if (bubble) sections.push('cart-icon-bubble');

    var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    var original = btn.innerHTML;
    btn.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'error'); return d; }); })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function') {          // Dawn-style cart drawer
          drawer.renderContents(data);
        } else if (bubble && data.sections && data.sections['cart-icon-bubble']) { // header cart count
          var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var s = doc.querySelector('.shopify-section');
          if (s) bubble.innerHTML = s.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cyl:added', { detail: data }));
        if (btn.closest('[data-cyl]').dataset.redirect === 'true' && !drawer) { window.location.href = root + 'cart'; return; }
        btn.classList.add('is-added'); btn.innerHTML = CHECK;
        setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = original; btn.disabled = false; }, 1600);
      })
      .catch(function (err) {
        btn.disabled = false;
        alert(err.message && err.message !== 'error' ? err.message : 'Could not add to cart. Please try again.');
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
